import { useMemo } from 'react'

import { MainContent, TopBar } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useCurrentUser from '@hooks/useCurrentUser'
import useMainNavigation from '@hooks/useMainNavigation'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import Notifications from '@components/Notifications'

import PackContext from '@contexts/packContext'

import MainNavigation from '@sections/Admin/components/MainNavigation'

import NewsDeskNavigation from './components/NewsDeskNavigation'
import NewsDeskRoutes from './routes'

const NewsDesk = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  const filterPayload = useFilters({ defaultFilters: { days_from_now: '0' } })

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = filterPayload

  const packContext: any = useMemo(() => ({
    callbacks: filterCallbacks,
    defaultFilters,
  }), [defaultFiltersModifiedAt])

  const currentUserPayload = useCurrentUser()
  const {
    isAdmin,
  } = currentUserPayload

  const nestedNavigation = isAdmin ? <NewsDeskNavigation pageFilters={pageFilters} /> : null
  const leftOffset = nestedNavigation ? undefined : 220

  return (
    <PackContext.Provider value={packContext}>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        nestedNavigation={!!nestedNavigation}
        notificationsComponent={<Notifications />}
        offset={{ left: leftOffset }}
        searchComponent={<DashboardSearch />}
      />

      <MainNavigation minimized={!!nestedNavigation} nestedNavigation={nestedNavigation} />

      <MainContent nestedNavigation={!!nestedNavigation} offset={{ left: leftOffset, top: TopBar.topBarHeight }}>
        <NewsDeskRoutes pageFilters={pageFilters} />
      </MainContent>
    </PackContext.Provider>
  )
}

export default NewsDesk
